/* eslint-disable prefer-rest-params */
export default function preload () {
	for (let i = 0; i < arguments.length; i++) {
		const img = new Image();
		img.src = arguments[i];
	}
}
